export default __webpack_public_path__ + "static/media/coolshop_logo.7ee7af45.svg";